/**
 * Elements with data-open-review-dialog attribute will open the dialog on click
 * Elements with data-close-review-dialog attribute will close the dialog on click
 *
 * To open the dialog via JS, trigger a custom event "open-review-dialog"
 * To close the dialog via JS, trigger a custom event "close-review-dialog"
 */
class ReviewDialog {
  #dialog;

  constructor() {
    this.#dialog = document.getElementById("review-dialog");
  }

  initialize() {
    if (!this.#dialog) {
      console.error(`Review dialog element not found`);
      return;
    }

    this.#registerEvents();
  }

  #openDialog() {
    this.#dialog.showModal();
  }

  #closeDialog() {
    this.#dialog.close();
  }

  #handleDocumentClick(event) {
    if (event.target.hasAttribute("data-open-review-dialog")) {
      event.preventDefault();
      this.#openDialog();
      return;
    }

    if (event.target.hasAttribute("data-close-review-dialog")) {
      event.preventDefault();
      this.#closeDialog();
      return;
    }

    // Close on backdrop click
    if (event.target.nodeName === "DIALOG" && event.target === this.#dialog) {
      this.#closeDialog();
      return;
    }
  }

  #registerEvents() {
    const clickHandler = this.#handleDocumentClick.bind(this);
    const openDialogHandler = this.#openDialog.bind(this);
    const closeDialogHandler = this.#closeDialog.bind(this);

    document.addEventListener("click", clickHandler);
    document.addEventListener("open-review-dialog", openDialogHandler);
    document.addEventListener("close-review-dialog", closeDialogHandler);
  }
}

if(document.getElementById("review-dialog")) {
  const reviewDialog = new ReviewDialog();
  reviewDialog.initialize();
}



const form = document.querySelector('#review-dialog form');

if (form) {
  const successMessage = '<div class="text-green-600 p-4 text-center font-semibold">Thank you! Your review was submitted successfully.</div>';

  const getSessionInfo = function() {
    return fetch('/actions/users/session-info', {
      headers: {
        'Accept': 'application/json',
      },
    })
    .then(response => response.json());
  };

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn.disabled) return;

    const originalBtnText = submitBtn.textContent;
    submitBtn.textContent = "Saving...";
    submitBtn.disabled = true;

    const formData = new FormData(form);
    const actionInput = form.querySelector('input[name="action"]').value;

    const previousError = form.querySelector('.form-error-message');
    if (previousError) previousError.remove();

    try {
      const session = await getSessionInfo();

      const response = await fetch('/actions/'+actionInput, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': session.csrfTokenValue,
          'X-Requested-With': 'XMLHttpRequest',
        }
      });

      const result = await response.json();

      if (response.ok) {
        form.outerHTML = successMessage;

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        throw new Error(result.error || 'There was a problem submitting your review.');
      }
    } catch (error) {
      const errorMessage = document.createElement('div');
      errorMessage.className = 'form-error-message text-red-500 mt-2';
      errorMessage.textContent = error.message;

      submitBtn.insertAdjacentElement('beforebegin', errorMessage);
      submitBtn.textContent = originalBtnText;
      submitBtn.disabled = false;
    }
  });
}
